const en = {
  optional: "(optional)",
  breadcrumb: "Breadcrumb",
  tabs: "Tabs",
  pagination: "Pagination",
  results: "{count} results",
  results_one: "{count} result",
  pageSummary: "Page {page} of {pages} · {total} results",
  working: "Working…",
  reason: "Reason",
  uploadFailed: "Upload failed",
  uploadHintPrivate: "PDF, ZIP, EPUB, MP3 or MP4 up to 100 MB — stored privately",
  uploadHintPublic: "PNG, JPEG, WebP, GIF or AVIF up to 10 MB",
  status_active: "Active",
  status_inactive: "Inactive",
  status_published: "Published",
  status_paid: "Paid",
  status_unpaid: "Unpaid",
  status_partially_paid: "Partially paid",
  status_captured: "Captured",
  status_fulfilled: "Fulfilled",
  status_unfulfilled: "Unfulfilled",
  status_partially_fulfilled: "Partially fulfilled",
  status_succeeded: "Succeeded",
  status_connected: "Connected",
  status_disconnected: "Disconnected",
  status_verified: "Verified",
  status_completed: "Completed",
  status_complete: "Complete",
  status_delivered: "Delivered",
  status_approved: "Approved",
  status_refunded: "Refunded",
  status_partially_refunded: "Partially refunded",
  status_draft: "Draft",
  status_archived: "Archived",
  status_cancelled: "Cancelled",
  status_canceled: "Cancelled",
  status_closed: "Closed",
  status_not_required: "Not required",
  status_expired: "Expired",
  status_pending: "Pending",
  status_awaiting_action: "Awaiting action",
  status_awaiting_confirmation: "Awaiting confirmation",
  status_requested: "Requested",
  status_setup_required: "Setup required",
  status_open: "Open",
  status_resolved: "Resolved",
  status_in_progress: "In progress",
  status_authorized: "Authorized",
  status_received: "Received",
  status_processed: "Processed",
  status_processing: "Processing",
  status_ignored: "Ignored",
  status_trialing: "Trial",
  status_shipped: "Shipped",
  status_failed: "Failed",
  status_error: "Error",
  status_disputed: "Disputed",
  status_suspended: "Suspended",
  status_rejected: "Rejected",
  status_reauth_required: "Reconnection required",
  status_past_due: "Past due",
  status_incomplete: "Incomplete",
  status_chargeback: "Chargeback",
  status_urgent: "Urgent",
  status_high: "High",
  status_normal: "Normal",
  status_low: "Low",
  status_void: "Void",
  status_uncollectible: "Uncollectible",
  status_queued: "Queued",
  status_running: "Running",
  status_done: "Done",
  status_sent: "Sent",
  status_logged: "Logged",
  status_suppressed: "Suppressed",
  status_unknown: "Unknown",
  status_converted: "Converted",
  status_missing: "Missing",
  status_partial: "Partial",
  status_outdated: "Outdated",
  status_undone: "Undone",
  status_scheduled: "Scheduled",
};

export default en;
